import React, {useState} from "react";
import items from './SliderGuia.json';
import Slider from "react-slick";
import SlideGuia from './SlideGuia';

const HeroGuia = () => {

  const [menuItem, setMenuItem] = useState(items);

    var settings = {
        className: "center",
        centerMode: true,
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 8000,
        speed: 2000,
        centerPadding: '130px',
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: false,
        responsive: [
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 1,
              className: "center",
              centerMode: true,
              slidesToScroll: 1,
              initialSlide: 0,
              centerPadding: '150px',
              dots: true
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              className: "center",
              centerMode: true,
              slidesToScroll: 1,
              initialSlide: 0,
              centerPadding: '150px',
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              className: "center",
              centerMode: true,
              slidesToScroll: 1,
              initialSlide: 0,
              centerPadding: '40px',
              dots: true
            }
          }
        ]
      };

    return (
        <section className="HeroGuia">
            <div className="wrap">
                <h1 className="titles">Nuestro <br /> contenido  <span>en vivo</span></h1>
            </div>
            <div>
                <Slider {...settings}>
                {
                  menuItem.map((videoBig) => {
                      return <SlideGuia id={videoBig.id} logocanal={videoBig.logocanal} titulo={videoBig.titulo} resena={videoBig.resena} screenshot={videoBig.screenshot} screenshotmobile={videoBig.screenshotmobile} screenshottablet={videoBig.screenshottablet} canal={videoBig.canal} tiempo={videoBig.tiempo} link={videoBig.link} />
                  })
                }
                </Slider>
            </div>
        </section>
      );
    }

  

    export default HeroGuia